<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="col-12">
              <div class="row">
                <div class="col-12 py-3 px-4 pt-4">
                  <div class="d-flex justify-content-between">
                    <h3
                      class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                    >
                      Modificar Evento
                    </h3>
                    <div class="">
                      <button
                        class="mt-2 btn-sm bg-primary text-white font-weight-normal border btn-outline-primary h5 btn d-flex flex-nowrap align-items-center"
                        @click.prevent="returnUrl"
                      >
                        <i class="bi bi-arrow-left mr-1"></i>
                        Volver
                      </button>
                    </div>
                  </div>
                  <form @submit.prevent="updateElement">
                    <div class="row">
                      <div class="col-12 col-sm-4 pl-0">
                        <div class="d-flex justify-content-center mb-4">
                          <img
                            v-if="form.url_image"
                            class="w-100 rounded"
                            :src="form.url_image"
                          />
                        </div>
                        <div id="app">
                          <file-pond
                            name="test"
                            ref="filePond"
                            label-idle=" Agrega la imagen aquí<br>( resolución recomendada: 1200x800 )"
                            v-bind:allow-multiple="false"
                            accepted-file-types="image/jpeg, image/png"
                            :server="null"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-8 px-0 pl-3">
                        <div class="row">
                          <div class="col-12 col-md-6 pr-md-2 pr-0 pl-0">
                            <label for="">Título del evento</label>
                            <input
                              type="text"
                              placeholder="Título"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.title"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pl-md-2 pl-0 pr-0">
                            <label for="">Fecha</label>
                            <input
                              type="date"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.date"
                              required
                            />
                          </div>
                          <div class="col-12 pl-0 pr-0">
                            <label for="">Descripción</label>
                            <textarea
                              cols="30"
                              rows="10"
                              placeholder="Descripción"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.short_description"
                              style="height: 60px"
                            ></textarea>
                          </div>
                          <div class="col-12 pl-0 pr-0">
                            <label for="">Contenido</label>
                            <vue-editor v-model="form.content"></vue-editor>
                          </div>
                          <div class="col-6 pl-0 pr-0" v-if="false">
                            <div class="d-flex justify-content-between">
                              <label for="status" class="pt-1"
                                >Mostrar en página principal:</label
                              >
                              <div style="padding-top: 2px">
                                <input
                                  type="checkbox"
                                  id="status"
                                  v-model="form.id_type_event_status"
                                  class="form-check-input mt-1 mb-3"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="d-flex justify-content-end w-100">
                        <button
                          type="submit"
                          class="bg-primary text-white font-weight-normal border btn-outline-primary h5 btn mb-0 mt-md-0 mb-2 mt-1"
                        >
                          Modificar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'

import { VueEditor } from 'vue2-editor'

import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  data() {
    return {
      form: {
        id: '',
        id_creator: '',
        title: '',
        date: '',
        short_description: '',
        content: '',
        slug: '',
        url_image: '',
        id_type_event_status: ''
      }
    }
  },
  components: {
    FilePond,
    VueEditor
  },
  methods: {
    ...mapActions(['getData', 'updateData', 'optimizeImage']),
    generateSlug(title) {
      return title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
    },

    getElement(id) {
      this.getData({ url: `event/${id}` })
        .then((response) => {
          this.form = {
            ...response.data,
            id_type_event_status: response.data.id_type_event_status == 1
          }
        })
        .catch((error) => {
          console.error(error)
          Swal.fire('Error', 'No se pudo cargar el evento.', 'error')
        })
    },

    updateElement() {
      if (
        this.form.title === '' ||
        this.form.date === '' ||
        this.form.content === '' ||
        this.form.short_description === ''
      ) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, complete todos los campos para continuar.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }

      this.form.slug = this.generateSlug(this.form.title)

      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de guardar este evento?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,

        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, Guardar'
      }).then(async (result) => {
        if (result.value) {
          const formData = new FormData() // Crear un objeto FormData
          formData.append('id_creator', this.form.id_creator)
          formData.append('title', this.form.title)
          formData.append('date', this.form.date)
          formData.append('short_description', this.form.short_description)
          formData.append('content', this.form.content)
          formData.append(
            'id_type_event_status',
            this.form.id_type_event_status ? 1 : 2
          )
          formData.append('slug', this.form.slug)
          const filePondInstance = this.$refs.filePond.getFiles()
          if (filePondInstance[0] && filePondInstance[0].file) {
            const compressedImage = await this.optimizeImage(
              filePondInstance[0].file
            )
            formData.append('url_image', compressedImage)
          }
          const form = {
            url: 'event/update',
            id: this.form.id,
            data: formData
          }

          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: 'Evento modificado correctamente',
                  icon: 'success',

                  confirmButtonText: 'Aceptar'
                }).then(() => {
                  this.returnUrl()
                })
              } else if (response.code === 409) {
                Swal.fire({
                  title: 'Error',
                  text: 'Ya existe un evento con ese título.',
                  icon: 'error',

                  confirmButtonText: 'Aceptar'
                })
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error, intente más tarde.',
                icon: 'error',

                confirmButtonText: 'Aceptar'
              })
            })
        }
      })
    },
    returnUrl() {
      this.$router.go(-1)
    }
  },

  mounted() {
    this.getElement(this.$route.params.id)
  }
}
</script>
